import React from 'react';
import classes from './style.module.css'

const ColoredBoxes = props => {

    const getBoxStyle= value => {
        let result = {
            backgroundColor: 'gray'
        }

        if(value === 'n/a') {

        }else if (value.startsWith('-')) {
            result = {
                backgroundColor: 'red'
            }
        }else {
            result = {
                backgroundColor: 'green'
            }
        }
        return result
    }

    return (
        <div className={classes.ColoredBoxes}>
            <div style={getBoxStyle(props.runnerElement.t1)}></div>
            <div style={getBoxStyle(props.runnerElement.t2)}></div>
            <div style={getBoxStyle(props.runnerElement.t3)}></div>
            <div style={getBoxStyle(props.runnerElement.t4)}></div>
            <div style={getBoxStyle(props.runnerElement.t5)}></div>
            <div style={getBoxStyle(props.runnerElement.t6)}></div>
        </div>
    );
}

export default ColoredBoxes;